import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100vh;
        max-height: 100vh;
        justify-content: center;
        overflow: hidden;
    `,
};
